export default __webpack_public_path__ + "static/media/CNo.85-0.77499eea.jpg";